import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "fishLoss";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    fishLossList: {
      list: [],
      total: 0
    }
  },
  actions: {
    //周期批次
    async getPondUnclearedBatchNo(a, pondId) {
      let result = await api.get(
        `/api/FishBatch/GetPondUnclearedBatchNo/${pondId}`
      );
      return result.data;
    },

    //查询-----获取损耗所有数据
    async getfishLossData({ commit }, payload) {
      let result = await api.get(
        `/api/FishLoss?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setfishLossList", result.data);
      }
      return result;
    },
    //添加
    async addFishLoss(a, payload) {
      let result = await api.post("/api/FishLoss", payload);
      return result.data;
    },
    //删除数据
    async delFishLossList(a, payload) {
      let result = await api.delete(`/api/FishLoss/` + payload);
      return result;
    },
    //删除子数据
    async delFishLossDetail(a, payload) {
      let result = await api.delete(`/api/FishLoss/Detail/${payload}`);
      return result;
    },
    //编辑---获取单行数据
    async getEditFishLossData(a, payload) {
      let result = await api.get(`/api/FishLoss/` + payload);
      return result.data;
    },
    //修改
    async updateFishLoss(a, payload) {
      let result = await api.put(`/api/FishLoss/${payload.id}`, payload.data);
      return result.data;
    }
  },
  mutations: {
    setfishLossList(state, payload) {
      state.fishLossList = payload;
    }
  },
  getters: {}
});

export default moduleName;
